module.exports = __webpack_public_path__ + "img/3-m.73907127.jpg";